module.exports = __webpack_public_path__ + "static/media/video2_cut.d024f2b4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/video2_cut.mp4
// module id = 805
// module chunks = 0